import { render } from "./BrandsBox.vue?vue&type=template&id=0c03f874"
import script from "./BrandsBox.vue?vue&type=script&lang=ts"
export * from "./BrandsBox.vue?vue&type=script&lang=ts"
script.render = render

export default script